var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3322_13761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7529 11.3811L18.2029 5.50108C17.8618 5.1393 17.2924 5.1228 16.9306 5.46419C16.5694 5.8053 16.5526 6.37498 16.894 6.73648L21.8611 11.9985L16.894 17.2612C16.5526 17.6227 16.5694 18.192 16.9306 18.5334C17.1046 18.6976 17.3269 18.7788 17.5483 18.7788C17.7874 18.7788 18.0262 18.6841 18.2029 18.4971L23.753 12.6168C24.0802 12.2697 24.0802 11.7279 23.7529 11.3811Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10467 17.2609L2.13786 11.9985L7.10467 6.73621C7.44579 6.37471 7.42929 5.80499 7.06778 5.46392C6.70656 5.12281 6.13656 5.13931 5.7955 5.50081L0.245462 11.3808C-0.0818208 11.7276 -0.0818208 12.2697 0.245462 12.6166L5.79578 18.4969C5.97278 18.6844 6.21128 18.7789 6.45039 18.7789C6.67178 18.7789 6.89411 18.6973 7.06778 18.5332C7.42961 18.1921 7.44579 17.6224 7.10467 17.2609Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4535 2.46866C12.9624 2.39427 12.5028 2.73144 12.4278 3.22255L9.78777 20.5027C9.71277 20.994 10.0503 21.4534 10.5417 21.5284C10.5879 21.5353 10.6335 21.5386 10.6788 21.5386C11.1159 21.5386 11.4993 21.2197 11.5674 20.7745L14.2074 3.49438C14.2824 3.00294 13.9449 2.54366 13.4535 2.46866Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3322_13761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(-0.00195312 -0.00146484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/Code.05b96381e2688fffd0ee92a23e43a320.svg";
export { ForwardRef as ReactComponent };